/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100DeviceMeasurementException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  RunMeasurementRequestDto,
  RunningMeasurementResponseDto,
} from '../models/index';
import {
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100DeviceMeasurementExceptionFromJSON,
    ErrorResponseOfPtw100DeviceMeasurementExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    RunMeasurementRequestDtoFromJSON,
    RunMeasurementRequestDtoToJSON,
    RunningMeasurementResponseDtoFromJSON,
    RunningMeasurementResponseDtoToJSON,
} from '../models/index';

export interface RunBccMeasurementRequest {
    runMeasurementRequestDto?: RunMeasurementRequestDto;
}

export interface StopBccMeasurementRequest {
    measurementId: string;
}

/**
 * 
 */
export class BccMeasurementsApi extends runtime.BaseAPI {

    /**
     * Starts a BCC measurement.
     */
    async runBccMeasurementRaw(requestParameters: RunBccMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/bcc/work-steps/run-measurement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunMeasurementRequestDtoToJSON(requestParameters['runMeasurementRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => RunningMeasurementResponseDtoFromJSON(jsonValue), "RunningMeasurementResponseDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 422: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100DeviceMeasurementExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100DeviceMeasurementException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => RunningMeasurementResponseDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Starts a BCC measurement.
     */
     async runBccMeasurement(requestParameters: RunBccMeasurementRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<BccMeasurementsApi['runBccMeasurementRaw']>>, RunningMeasurementResponseDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = RunningMeasurementResponseDto;

         const response = this.runBccMeasurementRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Cancels the given running BCC measurement.
     */
    async stopBccMeasurementRaw(requestParameters: StopBccMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['measurementId'] == null) {
            throw new runtime.RequiredError(
                'measurementId',
                'Required parameter "measurementId" was null or undefined when calling stopBccMeasurement().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/bcc/work-steps/{measurementId}/cancel`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters['measurementId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Cancels the given running BCC measurement.
     */
     async stopBccMeasurement(requestParameters: StopBccMeasurementRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<BccMeasurementsApi['stopBccMeasurementRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.stopBccMeasurementRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
